import { SET_DATA_REQUESTS } from './actiontypes';
import {
  getDataRequests,
  createDataRequest,
  addDataRequestAttachment,
  notifyOfDataRequest,
  saveDataRequest,
  deleteDataRequest,
} from '../../api/Api';

export const getDataRequestsAction =
  (selection = 'user', force = false) =>
  (dispatch, getState) => {
    const {
      user: { jwt },
      entities: {
        dataRequests: { loaded },
      },
    } = getState();
    if (loaded && !force) {
      return Promise.resolve('ok');
    }
    return getDataRequests(jwt, selection).then((data) =>
      dispatch({ type: SET_DATA_REQUESTS, data })
    );
  };

export const refetchDataRequestsAction = () => (dispatch) =>
  dispatch(getDataRequestsAction('all', true));

export const createDataRequestAction = (req) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return createDataRequest(req, jwt);
};

export const addAttachmentAction = (file, reqId, label) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return addDataRequestAttachment(file, reqId, label, jwt);
};

export const notifyOfDataRequestAction = (reqId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return notifyOfDataRequest(reqId, jwt);
};

export const saveDataRequestAction = (reqId, req) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return saveDataRequest(reqId, jwt, req);
};

export const deleteDataRequestAction = (reqId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return deleteDataRequest(reqId, jwt);
};
